import React from 'react';

function ListItem({
  title,
  link,
  country
}) {
  
  return (
    <>
      <a href={link} className="c-jobs-feed-list__link wrapper-link">
        <div className="c-jobs-feed-list__title">
            <h5>{title}</h5>
        </div>
        <div className="c-jobs-feed-list__country">
            {country}
        </div>
      </a>

    </>
  );
}

export default ListItem;
